import GlobalStyles from '@mui/material/GlobalStyles';
import { brand, chart, palettes, productColors, type Mode } from '@infinix/tokens';

function varsFor(mode: Mode): Record<string, string> {
  const p = palettes[mode];
  const out: Record<string, string> = {};
  for (const [k, v] of Object.entries(p)) out[`--ix-${k}`] = v;
  for (const [k, v] of Object.entries(productColors[mode])) out[`--ix-product-${k.toLowerCase()}`] = v;
  for (const [k, v] of Object.entries(brand)) out[`--ix-brand-${k}`] = v;
  chart.forEach((c, i) => { out[`--ix-chart-${i + 1}`] = c; });
  return out;
}

/**
 * Every token as a CSS variable, switched by `data-ix-mode` on <html>.
 * Components reference `var(--ix-*)`, so a mode switch repaints without re-rendering the tree.
 */
export function CssVars() {
  return (
    <GlobalStyles
      styles={{
        ':root, [data-ix-mode="light"]': varsFor('light'),
        '[data-ix-mode="dark"]': varsFor('dark'),
        body: { background: 'var(--ix-bg)', color: 'var(--ix-text)' },
        '.ix-mono': { fontFamily: "'IBM Plex Mono', ui-monospace, monospace", fontVariantNumeric: 'tabular-nums' },
        '::selection': { background: 'rgba(124,107,255,0.28)' },
        '@media (prefers-reduced-motion: reduce)': {
          '*': { animationDuration: '0.01ms !important', transitionDuration: '0.01ms !important' },
        },
      }}
    />
  );
}
